import { Position } from '@xyflow/react';
// Corner radius of every arrow. React Flow shrinks a corner to half the
// shorter segment beside it, so a segment needs twice this for a full corner.
export const SMOOTH_STEP_RADIUS = 12;
// On a line that turns next to a handle, how far it runs straight out first.
// Twice the radius, so that corner is a full corner too (React Flow's default
// of 20 gives it 10).
export const SMOOTH_STEP_OFFSET = 2 * SMOOTH_STEP_RADIUS;
// A forward line needs no stub, but 0 leaves a zero-length last segment and
// the arrowhead loses its direction (it points right in TB).
export const FORWARD_STEP_OFFSET = 1;
/** The axis a line's middle segment slides on. Only facing handles give a
 *  line one; it flips when the line doubles back. */
export function bendAxis(source, sourcePosition, target, targetPosition) {
    if (sourcePosition === Position.Right && targetPosition === Position.Left) {
        const forward = source.x < target.x;
        return { axis: forward ? 'x' : 'y', forward };
    }
    if (sourcePosition === Position.Bottom && targetPosition === Position.Top) {
        const forward = source.y < target.y;
        return { axis: forward ? 'y' : 'x', forward };
    }
    return null;
}
/** Keeps a dragged middle segment two radii clear of each end, so both
 *  corners stay full; halfway when there is no such room. */
export function clampBend(value, from, to, forward) {
    const leg = 2 * SMOOTH_STEP_RADIUS;
    if (forward) {
        const low = Math.min(from, to) + leg;
        const high = Math.max(from, to) - leg;
        if (low > high)
            return (from + to) / 2;
        return Math.min(high, Math.max(low, value));
    }
    let next = value;
    for (const end of [from, to]) {
        if (Math.abs(next - end) < leg)
            next = end + (next >= end ? leg : -leg);
    }
    return next;
}
// TB: each lower row's dot steps left, so lines running down past it miss
// it; the step wraps back at the row's left end. ELK reads this too.
const EXIT_INSET = 12;
const EXIT_STEP = 14;
export function exitInsetFromRight(index, rowWidth) {
    const steps = Math.max(1, Math.floor((rowWidth - 2 * EXIT_INSET) / EXIT_STEP) + 1);
    return EXIT_INSET + (index % steps) * EXIT_STEP;
}
//# sourceMappingURL=line-geometry.js.map